export enum ActionType {
  setNotifications = 'setNotifications',
  addTherapistsNote = 'addTherapistsNote',
}
